export default __webpack_public_path__ + "static/media/cashflowplan_graphic.62391cb3.svg";